const LOGIN_ERROR_CODE_KEYS = {
  StoreSubscriptionExpired: 'stores.access.reasons.subscriptionExpired.title',
  StoreTrialExpired: 'stores.access.reasons.trialExpired.title',
  StoreSubscriptionCanceled: 'stores.access.reasons.subscriptionCanceled.title',
  StoreSubscriptionSuspended: 'stores.access.reasons.subscriptionSuspended.title',
  StorePaymentMethodRequired: 'stores.access.reasons.paymentMethodRequired.title',
  StoreSubscriptionPastDue: 'stores.access.reasons.subscriptionPastDue.title',
  StoreExtraStoreDeactivated: 'stores.access.reasons.extraStoreDeactivated.title',
};

export const resolveLoginError = (error, t) => {
  const isNetworkError = !error?.response
    || error?.code === 'ECONNABORTED'
    || error?.code === 'ERR_NETWORK'
    || error?.message === 'Network Error'
    || (error?.response?.status >= 500);

  if (isNetworkError) {
    return {
      isNetworkError: true,
      errorKey: 'login.serverError',
      message: null,
    };
  }

  const responseData = error?.response?.data;
  const errorCode = responseData?.code;
  const apiMessage = responseData?.message || responseData?.description;

  if (errorCode && LOGIN_ERROR_CODE_KEYS[errorCode]) {
    return {
      isNetworkError: false,
      errorKey: LOGIN_ERROR_CODE_KEYS[errorCode],
      message: null,
    };
  }

  if (apiMessage) {
    return {
      isNetworkError: false,
      errorKey: null,
      message: apiMessage,
    };
  }

  return {
    isNetworkError: false,
    errorKey: 'login.invalid',
    message: null,
  };
};
